module.exports = __webpack_public_path__ + "static/media/callrail_logo.fe830daa.svg";